// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customize the color and icon of the month dropdown arrow */
.react-datepicker__month-read-view--down-arrow {
  display: none; /* Hide the default arrow */
}
.react-datepicker__month-read-view::after {
  content: "\\f078"; /* Unicode for down arrow */
  font-family: "Font Awesome 5 Free"; /* FontAwesome family */
  font-weight: 900;
  color: green;
  padding-left: 5px;
}

/* Customize the color and icon of the year dropdown arrow */
.react-datepicker__year-read-view--down-arrow {
  display: none; /* Hide the default arrow */
}
.react-datepicker__year-read-view::after {
  content: "\\f077"; /* Unicode for up arrow */
  font-family: "Font Awesome 5 Free"; /* FontAwesome family */
  font-weight: 900;
  color: green;
  padding-left: 5px;
}

.react-datepicker__navigation-icon::before {
  border-color: #fff;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}

/* .react-datepicker__navigation {
  background-color: #677caa;
} */

.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
  border-color: #677caa;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}

.custom-datepicker {
  width: 200px;
  font-family: Arial, sans-serif;
  /* Add more custom styles as needed */
}

/* Example of styling specific elements */
.react-datepicker__day--selected {
  background-color: #007bff;
  color: white;
}

.react-datepicker__day--keyboard-selected {
  background-color: #007bff;
  color: white;
}

.custom-calendar {
  /* Add your custom positioning styles here */
  position: absolute;
  top: 10px;
  left: 0;
}

.policiesdatepicker {
  width: 300px;
}

.custom-datepicker {
  width: 200px;
  font-family: Arial, sans-serif;
  /* Add more custom styles as needed */
}

.react-datepicker__day--selected {
  background-color: #007bff;
  color: white;
}

.react-datepicker__day--keyboard-selected {
  background-color: #007bff;
  color: white;
}

.custom-calendar {
  position: absolute;
  top: 10px;
  left: 0;
}

.policiesdatepicker {
  width: 300px;
}

/* Add Bootstrap's bi bi-down icon for the month dropdown */
.react-datepicker__month-read-view--down-arrow {
  display: none; /* Hide the default arrow */
}
.react-datepicker__month-read-view::after {
  content: "\\f078"; /* Unicode for down arrow */
  font-family: "Font Awesome 5 Free"; /* FontAwesome family */
  font-weight: 900;
  color: green;
  padding-left: 5px;
}

/* Add Bootstrap's bi bi-up icon for the year dropdown */
.react-datepicker__year-read-view--down-arrow {
  display: none; /* Hide the default arrow */
}
.react-datepicker__year-read-view::after {
  content: "\\f077"; /* Unicode for up arrow */
  font-family: "Font Awesome 5 Free"; /* FontAwesome family */
  font-weight: 900;
  color: green;
  padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/PlanB/PoliciesKYCForm.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,aAAa,EAAE,2BAA2B;AAC5C;AACA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,kCAAkC,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,aAAa,EAAE,2BAA2B;AAC5C;AACA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,kCAAkC,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,aAAa,EAAE,2BAA2B;AAC5C;AACA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,kCAAkC,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,aAAa,EAAE,2BAA2B;AAC5C;AACA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,kCAAkC,EAAE,uBAAuB;EAC3D,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* Customize the color and icon of the month dropdown arrow */\r\n.react-datepicker__month-read-view--down-arrow {\r\n  display: none; /* Hide the default arrow */\r\n}\r\n.react-datepicker__month-read-view::after {\r\n  content: \"\\f078\"; /* Unicode for down arrow */\r\n  font-family: \"Font Awesome 5 Free\"; /* FontAwesome family */\r\n  font-weight: 900;\r\n  color: green;\r\n  padding-left: 5px;\r\n}\r\n\r\n/* Customize the color and icon of the year dropdown arrow */\r\n.react-datepicker__year-read-view--down-arrow {\r\n  display: none; /* Hide the default arrow */\r\n}\r\n.react-datepicker__year-read-view::after {\r\n  content: \"\\f077\"; /* Unicode for up arrow */\r\n  font-family: \"Font Awesome 5 Free\"; /* FontAwesome family */\r\n  font-weight: 900;\r\n  color: green;\r\n  padding-left: 5px;\r\n}\r\n\r\n.react-datepicker__navigation-icon::before {\r\n  border-color: #fff;\r\n  border-style: solid;\r\n  border-width: 3px 3px 0 0;\r\n  content: \"\";\r\n  display: block;\r\n  height: 9px;\r\n  position: absolute;\r\n  top: 6px;\r\n  width: 9px;\r\n}\r\n\r\n/* .react-datepicker__navigation {\r\n  background-color: #677caa;\r\n} */\r\n\r\n.react-datepicker__navigation-icon--next::before {\r\n  transform: rotate(45deg);\r\n  left: -7px;\r\n}\r\n\r\n.react-datepicker__year-read-view--down-arrow,\r\n.react-datepicker__month-read-view--down-arrow,\r\n.react-datepicker__month-year-read-view--down-arrow,\r\n.react-datepicker__navigation-icon::before {\r\n  border-color: #677caa;\r\n  border-style: solid;\r\n  border-width: 3px 3px 0 0;\r\n  content: \"\";\r\n  display: block;\r\n  height: 9px;\r\n  position: absolute;\r\n  top: 6px;\r\n  width: 9px;\r\n}\r\n\r\n.custom-datepicker {\r\n  width: 200px;\r\n  font-family: Arial, sans-serif;\r\n  /* Add more custom styles as needed */\r\n}\r\n\r\n/* Example of styling specific elements */\r\n.react-datepicker__day--selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.react-datepicker__day--keyboard-selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.custom-calendar {\r\n  /* Add your custom positioning styles here */\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 0;\r\n}\r\n\r\n.policiesdatepicker {\r\n  width: 300px;\r\n}\r\n\r\n.custom-datepicker {\r\n  width: 200px;\r\n  font-family: Arial, sans-serif;\r\n  /* Add more custom styles as needed */\r\n}\r\n\r\n.react-datepicker__day--selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.react-datepicker__day--keyboard-selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.custom-calendar {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 0;\r\n}\r\n\r\n.policiesdatepicker {\r\n  width: 300px;\r\n}\r\n\r\n/* Add Bootstrap's bi bi-down icon for the month dropdown */\r\n.react-datepicker__month-read-view--down-arrow {\r\n  display: none; /* Hide the default arrow */\r\n}\r\n.react-datepicker__month-read-view::after {\r\n  content: \"\\f078\"; /* Unicode for down arrow */\r\n  font-family: \"Font Awesome 5 Free\"; /* FontAwesome family */\r\n  font-weight: 900;\r\n  color: green;\r\n  padding-left: 5px;\r\n}\r\n\r\n/* Add Bootstrap's bi bi-up icon for the year dropdown */\r\n.react-datepicker__year-read-view--down-arrow {\r\n  display: none; /* Hide the default arrow */\r\n}\r\n.react-datepicker__year-read-view::after {\r\n  content: \"\\f077\"; /* Unicode for up arrow */\r\n  font-family: \"Font Awesome 5 Free\"; /* FontAwesome family */\r\n  font-weight: 900;\r\n  color: green;\r\n  padding-left: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
